export const GAME_ACTION_TYPES = [
  "recordPlateAppearance",
  "adjustRunner",
  "removeRunner",
  "addOpponentRun",
  "endHalfInning",
  "updateLiveSetup",
  "finalizeGame",
  "attributeRbi",
] as const;

export type GameActionType = (typeof GAME_ACTION_TYPES)[number];

export const UNDOABLE_GAME_ACTION_TYPES = [
  "recordPlateAppearance",
  "adjustRunner",
  "removeRunner",
  "addOpponentRun",
  "endHalfInning",
] as const satisfies readonly GameActionType[];

export const PREGAME_ACTION_TYPES = [
  "setAttendance",
  "setOpponentName",
  "setHomeTeam",
  "setScheduleDetails",
  "setOpenInning",
  "setPitcher",
  "setJerseyHolder",
  "setTeamName",
  "reorderLineup",
  "setDefenseAssignment",
  "regenerateDefense",
  "addPlayer",
  "updatePlayer",
  "removePlayer",
] as const;

export type PregameActionType = (typeof PREGAME_ACTION_TYPES)[number];

export function isGameActionType(value: unknown): value is GameActionType {
  return GAME_ACTION_TYPES.some((type) => type === value);
}

export function isPregameActionType(
  value: unknown,
): value is PregameActionType {
  return PREGAME_ACTION_TYPES.some((type) => type === value);
}
